// extracted by mini-css-extract-plugin
module.exports = {"FullWindowHeight":"Home_FullWindowHeight__22SKi"};